<div style="position: relative">
  <div class="_2hVSre heart">
    <!-- <div class="_36FSn5" (click)="click(product.product_id)"> -->
    <button class="_36FSn5 heartBtn" (click)="openDialog(product)">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="heart-fill"
        width="28"
        height="28"
        viewBox="0 0 20 16"
        [ngClass]="{
          'heart-red-fill': product.added_shopping_list_ids,
          'heart-empty-fill': !product.added_shopping_list_ids
        }"
      >
        <path
          d="M8.695 16.682C4.06 12.382 1 9.536 1 6.065 1 3.219 3.178 1 5.95 1c1.566 0 3.069.746 4.05 1.915C10.981 1.745 12.484 1 14.05 1 16.822 1 19 3.22 19 6.065c0 3.471-3.06 6.316-7.695 10.617L10 17.897l-1.305-1.215z"
          class="eX72wL"
          stroke="#FFF"
          fill-rule="evenodd"
          opacity=".9"
        ></path>
      </svg>
    </button>
    <!-- </div> -->
  </div>
  <a routerLink="/product/{{ product.slug }}">
    <div class="_prBox">
      <div class="bstSellrs" *ngIf="bstCheck">
        {{ "Best Sellers" | translate }}
      </div>
      <div class="img">
        <img
          loading="lazy"
          src="{{ product.featured_image_name }}"
          alt="image"
        />
      </div>
      <div class="cartFiller-base-info">
        <span class="rating">
          <div class="rating-img">
            4.5<img
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMiI+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTYuNSA5LjQzOWwtMy42NzQgMi4yMy45NC00LjI2LTMuMjEtMi44ODMgNC4yNTQtLjQwNEw2LjUuMTEybDEuNjkgNC4wMSA0LjI1NC40MDQtMy4yMSAyLjg4Mi45NCA0LjI2eiIvPjwvc3ZnPg=="
              class="_1wB99o"
            />
          </div>
        </span>
        <div class="cartFiller-base-brandName">
          {{ product.product_name | titlecase }}
        </div>
        <!-- <div class="cartFiller-base-productDescription"></div> -->
        <!-- <div class="cartFiller-base-priceInfo">
                        <i><img src="assets/images/sold.png" alt="image" /></i>
                        <span class="cartFiller-base-boldtext pl-2"
                          >{{ "Sold By" | translate }} :
                          <span class="cartFiller-base-sold-by">
                            {{ product.sold_by | titlecase }}
                          </span>
                        </span>
                      </div> -->
        <div class="cartFiller-base-priceInfo" *ngIf="!product.discount_price">
          <span class="cartFiller-base-boldtext">${{ product.price }}</span>
        </div>
        <div class="cartFiller-base-priceInfo" *ngIf="product.discount_price">
          <span class="cartFiller-base-boldtext"
            >${{ product.discount_price }}</span
          >
          <span>
            <span class="cartFiller-base-originalPrice"
              >${{ product.price }}</span
            >
          </span>
        </div>
      </div>
    </div>
  </a>
</div>
